import { Bounty } from 'src/app/interfaces/Bounty';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { Comment } from './comments-section/comments-section.component';

@Component({
  selector: 'app-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss'],
})
export class CommentsComponent implements OnInit {
  private subscriptions: Subscription[] = [];
  public bounties: Bounty & {comments: Comment[] }[];

  constructor(
    private route: ActivatedRoute,
  ) {
    this.subscriptions.push(
      route.data.subscribe(({ data }) => {
        this.mapDataToState(data);
      }),
    );
  }

  ngOnInit() {
  }

  private mapDataToState({ bounties }) {
    this.bounties = bounties;
  }

}
